import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import QuteContainer from "../containers/global/global-qute/index.jsx";
import PortfolioContainer from "../containers/global/portfolio-trailer/index.jsx";
import IntroContainer from "../containers/home/intro/index.jsx";
import Footer from "../layouts/footer";
import Header from "../layouts/header/index";
import Layout from "../layouts/index";
import { Link } from "react-router-dom";

const HomePage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Joana Beste" />
                <div className="wrapper home-default-wrapper">
                    <Header />
                    <IntroContainer />
                    <div className="main-content">
                        <QuteContainer />

                        <PortfolioContainer />
                        <div className="font-size-16 text-center m-5">
                            <Link to={process.env.PUBLIC_URL + "/portfolio"}>
                                Mehr ansehen
                            </Link>
                        </div>
                    </div>
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default HomePage;
